<div class="popover-cell" *ngIf="!showCommonFile">
    <span class="job-link" >
        <ng-container [ngSwitch]="data?.recordType">
            <!-- Customer -->
            <a *ngSwitchCase="'customer'"
               href="/customers/customer/{{data.recordId}}/view_v2/communications/view"
               target="_blank" rel="noopener noreferrer" class="link-text-color">
                 <span style="color:#3883c1; cursor:pointer;">{{ data?.recordType | titlecase }} {{ data?.recordId }}</span>
            </a>

            <!-- Contract -->
            <a *ngSwitchCase="'contract'"
               href="/customers/customer/{{data?.customerDetails?.customerId}}/customer_contracts/{{data?.customerContractId}}/view"
               target="_blank" rel="noopener noreferrer" class="link-text-color">
                <span style="color:#3883c1; cursor:pointer;">{{ data?.recordType | titlecase }} {{ data?.customerContractId }}</span>
            </a>

            <!-- Opportunity -->
            <a *ngSwitchCase="'Opportunity'"
               href="/customers/customer/{{data?.customerDetails.customerId}}/opportunity/{{data.recordId}}/view"
               target="_blank" rel="noopener noreferrer" class="link-text-color">
                 <span style="color:#3883c1; cursor:pointer;" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()">{{ data?.recordType | titlecase }} {{ data?.recordId }}</span>
            </a>

            <!-- Job / Others -->
            <a *ngSwitchDefault
               href="/customers/customer/{{data?.customerDetails?.customerId}}/jobs_v2/{{data.recordId}}/details/view"
               target="_blank" rel="noopener noreferrer" class="link-text-color">
                 <span style="color:#3883c1; cursor:pointer;" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()">{{ data?.recordType | titlecase }} {{ data?.recordId }}</span> <br> <span>{{data?.recordDescription}}</span>
            </a>
        </ng-container>
    </span>
</div>
<div class="popover-cell" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()" *ngIf="showCommonFile">
    <span class="job-link" >{{params?.nametohover}}</span>
</div>




